export function calculateImagePaddings(region, imageWidth, maxWidth) {
    let outlookImagePaddingLeft;
    let outlookImagePaddingRight;
    let imagePaddingLeft;
    let imagePaddingRight;
    let adjustedimageWidth = imageWidth;
    if (region.data?.styles?.region?.paddingRight ||
        region.data?.styles?.region?.paddingLeft) {
        // NOTE: Code below is written with assumption that paddingLeft and
        // paddingRight are equal or one of them is zero.
        const paddingRight = region.data.styles.region.paddingRight?.endsWith('%')
            ? parseInt(region.data.styles.region.paddingRight, 10)
            : undefined;
        const paddingLeft = region.data.styles.region.paddingLeft?.endsWith('%')
            ? parseInt(region.data.styles.region.paddingLeft, 10)
            : undefined;
        const imageScale = 100 - ((paddingLeft || 0) + (paddingRight || 0));
        adjustedimageWidth = Math.floor((imageWidth * imageScale) / 100);
        const totalPadding = ((maxWidth - adjustedimageWidth) * 100) / maxWidth;
        imagePaddingLeft =
            paddingRight === undefined
                ? totalPadding
                : paddingLeft !== undefined
                    ? totalPadding / 2
                    : 0;
        imagePaddingRight =
            paddingLeft === undefined
                ? totalPadding
                : paddingRight !== undefined
                    ? totalPadding / 2
                    : 0;
        outlookImagePaddingLeft = (imagePaddingLeft * maxWidth) / 100;
        outlookImagePaddingRight = (imagePaddingRight * maxWidth) / 100;
    }
    return {
        imagePaddingLeft,
        imagePaddingRight,
        outlookImagePaddingLeft,
        outlookImagePaddingRight,
        adjustedimageWidth,
    };
}
//# sourceMappingURL=calculate-image-paddings.js.map